import { PagePermission } from "../app/models/responseModels/loginResponse";

export function checkPageAndPagePath(
  pagePermissions: PagePermission[],
  pagePathName?: string,
  pageName?: string
) {
  if (pagePathName) {
    return (
      pagePermissions.filter((x) => x.pagePath === pagePathName).length >
      0
    );
  }
  if (pageName) {
    return (
      pagePermissions.filter((x) => x.pageName === pageName).length > 0
    );
  }
}
